import {
  ChakraButton,
  ChakraDrawer,
  ChakraDrawerBody,
  ChakraDrawerCloseButton,
  ChakraDrawerContent,
  ChakraDrawerOverlay,
  ChakraFlex,
  FAIconName,
  Icon,
} from '@equip.health/ui';
import { EditNoteDrawerBody } from '~/components/maud/patients/note/EditNoteDrawerBody';
import { useEditNoteDrawerContext } from '~/lib/contexts/EditNoteDrawerContext';
import { useEditPatientNoteFormContext } from '~/lib/contexts/EditPatientNoteFormContext';
import { EditNoteDrawerMinimizedButton } from '~/components/common/EditNoteDrawerMinimizedButton';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { PatientEvents } from '~/analytics/patientEvents';

const EDIT_NOTE_DRAWER_WIDTH = '1200px';

export const EditNoteDrawer = () => {
  const { drawerStatus } = useEditNoteDrawerContext();
  const { trackEvent } = useAnalytics();
  const { saveAndCloseNoteDrawer, isLoading, saveAndMinimize } =
    useEditPatientNoteFormContext();

  const isOpen = drawerStatus === 'open';

  return (
    <>
      <ChakraDrawer isOpen={isOpen} onClose={saveAndCloseNoteDrawer}>
        <ChakraDrawerOverlay />
        <ChakraDrawerContent
          background="neutral.background.primary"
          maxWidth={EDIT_NOTE_DRAWER_WIDTH}
        >
          <ChakraFlex gap="4px" position="absolute" right="29px" top="24px">
            <ChakraButton
              aria-label="Minimize"
              height="32px"
              isDisabled={isLoading}
              minWidth="28px"
              onClick={() => {
                trackEvent(PatientEvents.collapseSessionGuideDrawer);
                saveAndMinimize();
              }}
              paddingX="2px"
              variant="ghost"
            >
              <Icon color="neutral.primary" name={FAIconName.arrowDownRight} />
            </ChakraButton>
            <ChakraDrawerCloseButton
              alignItems="center"
              isDisabled={isLoading}
              position="unset"
            />
          </ChakraFlex>
          <ChakraDrawerBody padding="0px">
            <EditNoteDrawerBody />
          </ChakraDrawerBody>
        </ChakraDrawerContent>
      </ChakraDrawer>
      <EditNoteDrawerMinimizedButton />
    </>
  );
};
